import "core-js/modules/es.array.push.js";
import httpRequest from '@/request/index';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { showToast, showFailToast, showLoadingToast, closeToast } from 'vant';
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    let formData = computed(() => {
      return store.state.userInfo;
    });
    function saveInfo() {
      if (formData.value.shop_name == "") {
        showFailToast("店铺名不能为空");
        return false;
      }
      if (formData.value.true_name == "") {
        showFailToast("联系人不能为空");
        return false;
      }
      if (formData.value.user_wechar == "") {
        showFailToast("微信号不能为空");
        return false;
      }
      showLoadingToast({
        message: '保存中',
        forbidClick: true
      });
      httpRequest({
        method: "post",
        url: "?file=user&act=info",
        data: formData.value
      }).then(res => {
        closeToast();
        console.log(res);
        if (res.state == 1) {
          showToast({
            message: "修改成功",
            onClose: function () {
              router.push("/user");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
    }
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      formData,
      saveInfo,
      goBack
    };
  }
};